'use strict';

const createWidgetFactory = require('components-framework/widget/create_widget_factory');

module.exports = createWidgetFactory({
    name: 'psd2_communication_popup',
    viewClass: require('./view'),
    methods: {
        open() {
            this.open();
        },
    },
});
